import React from "react";
import { Link, useNavigate } from "react-router-dom";
import FucaScoreLogo from "../../Assets/Images/fucascore_png.png";

export default function FSNavigation() {
  const navigate = useNavigate();

  const handleNavClick = (path) => {
    navigate(path);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <nav className="fs-navigation">
      {/* Lijevo: Logo FucaScore koji vodi na naslovnu */}
      <div onClick={() => handleNavClick("/")} style={{ cursor: "pointer" }}>
        <img className="logo" src={FucaScoreLogo} alt="FucaScore Logo" />
      </div>

      {/* Sredina: Naziv aplikacije */}
      <div
        className="center-section"
        onClick={() => handleNavClick("/")}
        style={{ cursor: "pointer" }}
      >
        <span className="text-title">FucaScore</span>
      </div>

      <Link to="/pokreni-turnir" className="join-btn">
        <i className="fi fi-sr-play"></i>{" "}
      </Link>
    </nav>
  );
}
